<mat-sidenav-container class="full-height" hasBackdrop="false">
    <mat-sidenav-content id="main">
        <anonymous-toolbar></anonymous-toolbar>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
